// extracted by mini-css-extract-plugin
export default {"wrapper":"treemap-chart_wrapper__Riza6","container":"treemap-chart_container__h6BfY","legend":"treemap-chart_legend__icRDY"};